import React from 'react';
import { Map, TileLayer, GeoJSON } from 'react-leaflet';
import './styles.scss';
import counties from './services/flcountiesboundaries.json';

class CountiesMap extends React.Component {

  constructor() {
    super();
    this.state = {
      map: {
        lat: 27.94,
        lng: -83.27,
        zoom: 6
      },
      selected: '',
      mapKey: 0
    };
  }

  updateCountyOnMap(countyFp){
    this.setState({
      selected: countyFp
    }, () => {
      this.setState({
        mapKey: this.state.mapKey+1
      })
    });
  }

  geoJSONStyle(obj) {
    let color;
    let regions = {
      north :['127','083','075','035','107', '109', '029', '007', '019', '031', '089','001', '041', '003', '125', '023', '121', '067', '047', '123', '079', '065', '073', '129', '037', '077', '039', '045', '013', '063', '005', '133', '059', '131', '091', '113', '033'],
      central: ['115', '027', '055', '093', '085', '111', '061', '081', '049', '097', '009', '095', '105', '057', '103', '101', '053', '119', '069', '017', '117'],
      south: ['087','086','011','099', '021', '071', '051', '043','015']
    }
    if(regions.north.includes(obj.properties.COUNTYFP)){
      color = '#ff8c66'
    }else if(regions.central.includes(obj.properties.COUNTYFP)){
      color = '#00b300'
    }else if(regions.south.includes(obj.properties.COUNTYFP)){
      color = '#3399ff'
    }
    return {
      'color': color,
    }
 }

  onEachFeature(feature, layer) {
    
    let countySelected = this.state.selected;

    layer.on({
      add: function(){
        if(layer.feature.properties.COUNTYFP === countySelected){
          layer.setStyle({
            'color': 'gray'
          });
          layer.bringToFront();
          layer.openPopup();
        }else{
          layer.bringToBack();
        }
      },
      click: this.clickToFeature.bind(this)
    });
    layer.bindPopup(layer.feature.properties.NAME);
  }

  clickToFeature(e) {
    let layer = e.target;
    //Update parent property
    this.props.selectValue(layer.feature.properties.COUNTYFP, 'map');
    //Assign new selected
    this.setState({
      selected: layer.feature.properties.COUNTYFP
    });
    // Bring selected to front
    layer.bringToFront();
    // Style selected
    layer.setStyle({
      'color': 'gray'
    });

  }

  render() {
   const position = [this.state.map.lat, this.state.map.lng];

   return (
     <Map id='map' center={position} zoom={this.state.map.zoom} key={this.state.mapKey}>
        <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"/>
        <GeoJSON data={counties} style={this.geoJSONStyle} onEachFeature={this.onEachFeature.bind(this)} />
     </Map>
   );
  }
}

export default CountiesMap;
